module.exports = __webpack_public_path__ + "public/img/edit.e95b8ff3.png";